import Script from 'next/script'

export function KlaviyoActiveOnSiteScript() {
  const publicKey = import.meta.graphCommerce.klaviyoPublicKey

  return <Script src={`https://static.klaviyo.com/onsite/js/${publicKey}/klaviyo.js`} async />
}
